import { React, useEffect, useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { getAllTopics } from "../../services/AttendanceServices";
import { toast } from 'react-toastify';
import { Box, Divider, Tooltip } from '@mui/material';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import AllTopicsList from './AllTopicsList';
import TrackScoreModal from './TrackScoreModal';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';

export default function AllTopics() {
  const [rows, setRows] = useState([]);
  const [showTrackModal, setShowTrackModal] = useState(false);
  const [selectedTrack, setSelectedTrack] = useState(null);

  const fetchData = async () => {
    try {
      const response = await getAllTopics();
      setRows(response?.data?.data || []);
    } catch (error) {
      toast.error(error?.response?.message || error?.response?.data?.message || 'Something went wrong');
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  const handleTrackClick = (track) => {
    setSelectedTrack(track);
    setShowTrackModal(true);
  };

  return (
    <Box sx={{ width: '100%', px: { xs: 1, md: 3 }, py: 2, }}>
      {rows["trackScores"]?.map((data) => (
        <Accordion key={data?.moduleID} sx={{ mb: 2, borderRadius: 2, boxShadow: 3, }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`panel-${data?.moduleID}-content`}
            id={`panel-${data?.moduleID}-header`}
            sx={{
              bgcolor: '#f5f5f5',
              px: 2,
              py: 1,
            }}
          >
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                justifyContent: 'space-between',
                alignItems: { xs: 'flex-start', sm: 'center' },
                gap: 1,
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  {data?.review_status === "completed" &&
                    // <Tooltip title="Completed" arrow>
                    <CheckCircleRoundedIcon sx={{ color: 'green', fontSize: '1.5rem', cursor: 'pointer' }} />
                    // </Tooltip>
                  }
                  {data?.review_status === "In_progress" &&
                    // <Tooltip title="In Progress" arrow>
                    <HourglassTopIcon sx={{ color: 'orange', fontSize: '1.5rem', cursor: 'pointer' }} />
                    // </Tooltip>
                  }
                  {data?.review_status === "pending" &&
                    // <Tooltip title="Pending" arrow>
                    <CancelRoundedIcon sx={{ color: 'red', fontSize: '1.5rem', cursor: 'pointer' }} />
                    // </Tooltip>
                  }

                </Box>

                <Typography
                  component="span"
                  sx={{
                    fontWeight: 600,
                    fontSize: { xs: '1rem', sm: '1.1rem' },
                    wordBreak: 'break-word',
                  }}
                >
                  {data?.topic_Name}
                </Typography>
              </Box>

              <Box sx={{
                display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, alignItems: { xs: 'flex-start', sm: 'center' }, gap: { xs: 1, sm: 5 }, mr: { sm: '0', md: "1rem" },
              }}>
                {data?.track_score &&
                  <Typography
                    component="span"
                    sx={{
                      fontSize: { xs: '0.9rem', sm: '1rem' },
                      textDecoration: 'underline',
                      cursor: 'pointer',
                      color: '#1976d2',
                      fontWeight: 500,
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleTrackClick(data);
                    }}
                  >
                    Track Score: {data?.track_score}
                  </Typography>
                }{data?.review_date &&
                  <Typography
                    component="span"
                    sx={{
                      fontSize: '0.85rem',
                      color: 'text.secondary',
                      fontWeight: 500,
                    }}
                  >
                    Review Date:{data.review_date
                      ? new Date(data.review_date).toLocaleDateString('en-GB')
                      : '--'}
                  </Typography>}
              </Box>
            </Box>
          </AccordionSummary>
          <Divider />
          <AccordionDetails sx={{ p: 2 }}>
            <AllTopicsList topics={data} />
          </AccordionDetails>
          <TrackScoreModal
            open={showTrackModal}
            handleClose={() => setShowTrackModal(false)}
            trackData={selectedTrack}
          />
        </Accordion>
      ))}
    </Box>
  );
}
